import React from 'react';

// style='height:auto; width:auto; max-height:30px;'

const ArrowUp = ( isNew ) => {

    console.log(isNew.isNew);

  return (
    <span>
        {!isNew.isNew ? "" : <img className = 'arrow-up-image' src='/images/arrow_up_green.png' border='0' data-toggle="tooltip" title="Donations made less than 24 hours ago!" />}
    </span>
  );
}

export default ArrowUp;



